import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";
import { AlertTriangle } from "lucide-react";

/**
 * Reusable confirmation dialog for irreversible delete actions.
 * 
 * @param {boolean} open - Whether the dialog is open
 * @param {function} onOpenChange - Callback when open state changes
 * @param {string} title - Dialog title (e.g., "Elimina Payment Link")
 * @param {string} description - Description of what will be deleted
 * @param {string} itemCount - Optional count of items (e.g., "3 elementi")
 * @param {function} onConfirm - Callback when user confirms deletion
 * @param {boolean} loading - Whether deletion is in progress
 */
export default function DeleteConfirmDialog({
  open,
  onOpenChange,
  title = "Conferma Eliminazione",
  description = "Questa azione è irreversibile.",
  itemCount,
  onConfirm,
  loading = false
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="bg-white border-red-200">
        <AlertDialogHeader>
          <div className="flex items-center gap-3">
            <div className="p-2 bg-red-100 rounded-full">
              <AlertTriangle className="h-6 w-6 text-red-600" />
            </div>
            <AlertDialogTitle className="text-xl font-heading text-[#1C1917]">
              {title}
            </AlertDialogTitle>
          </div>
          <AlertDialogDescription className="text-[#78716C] pt-4">
            {itemCount && (
              <span className="block font-semibold text-[#1C1917] mb-2">
                {itemCount}
              </span>
            )}
            {description}
            <span className="block mt-3 text-red-600 font-semibold">
              ⚠️ Questa azione è IRREVERSIBILE e i dati verranno eliminati definitivamente dal database.
            </span>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="mt-4">
          <AlertDialogCancel 
            className="bg-[#F5F5F4] hover:bg-[#E7E5E4] text-[#1C1917] border-[#E7E5E4]"
            disabled={loading}
          >
            Annulla
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={loading}
            className="bg-red-600 hover:bg-red-700 text-white"
            data-testid="confirm-delete-btn"
          >
            {loading ? "Eliminazione..." : "Elimina Definitivamente"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
